import {
    AllOrdersPage,
    AllUsersPage,
    AppPaths,
    AuthnObserver, AutomatedIfPresetScalesPage,
    CartPage,
    ChromogenPresetScalesPage,
    defaultUiConfig,
    EncoderTrackingPage,
    FluorescentHairpinTrackingPage,
    getWithAuthn,
    GOOGLE_ANALYTICS4_ID,
    GOOGLE_ANALYTICS_ID,
    InventoryPage,
    LogInPage,
    LogOutPage, ManualBufferTrackingPage,
    ManualStarterKitForm,
    MarketingReferralsPage, NewChromogenKitPage, NewKitPage,
    NewManualGoldIfKitPage, NewManualProConsumerKitPage, NewMultiPlexProKitPage, NewRegistrationPage, NewRnaFishKitPage,
    NewSecondaryIfKitPage,
    OrderUploadPoPage, PresetScalesPage, ProbeLotTablePage,
    ProDetectPresetScalesPage,
    ProfilePage,
    ProProbePresetScalesPage, ProStarterKitForm,
    ReportsPage,
    ResetPasswordPage,
    RnaCatalogPage,
    SecondaryIfProbeTrackingPage,
    ShopLink,
    ShopRedirect,
    SingleOrderPage,
    SingleUserPage,
    StarterKitsPage,
    TrackingPage,
    UiConfig,
    UiConfigContext,
    UserOrderListPage,
    UserOrderPage,
    VerifyEmailPage
} from "@web-ui/common";
import * as React from 'react';
import {RouteComponentProps, RouterProps, useLocation} from "react-router";
import {BrowserRouter as Router, Link, NavLink, Route, Switch} from 'react-router-dom';
import {Dropdown, Icon, Menu, Message} from "semantic-ui-react";
import hcrImg from './images/hcr-tm-automated-white-with-text.png';
import lifeImg from './images/ImagingTheMoleculesOfLife.png';
import logoImg from './images/MI-logo-final_White.png';

class App extends React.Component<{}, AppState> {

    private readonly authnObserver = new AuthnObserver(() => {
        this.setState({
            uiConfig: defaultUiConfig()
        }, () => this.loadUiConfig())
    });

    constructor(props: {}) {
        super(props);

        this.state = {
            uiConfig: defaultUiConfig(),
            pathname: ""
        }
    }

    public componentDidMount(): void {
        this.loadUiConfig()
    }

    public render() {
        const admin = this.state.uiConfig.uiFeatures.has(FEATURE_SHOW_ADMIN_MENU);
        const reports = this.state.uiConfig.uiFeatures.has(FEATURE_REPORTS);

        return <React.StrictMode>
            <UiConfigContext.Provider value={this.state.uiConfig}>
                <Router>
                    <div className="App">
                        <header>
                            {/*<Message color={"yellow"} style={{marginBottom: '0', borderRadius: '0'}}>*/}
                            {/*    <h1 className={'mi-branded-banner'}>*/}
                            {/*        <strong>Weather Update:</strong> Winter storms are impacting shipping and may cause delays.*/}
                            {/*    </h1>*/}
                            {/*</Message>*/}
                            <div className={'branding'}>
                                <div className={'mi-logo-div'}>
                                    <a href={"https://www.molecularinstruments.com"}>
                                        <img
                                            alt={'logo'}
                                            src={logoImg}
                                            className={'mi-new-logo'}
                                        />
                                    </a>
                                </div>

                                <div className={'life-div'}>
                                    <a href={"https://www.molecularinstruments.com/about"}>
                                        <img
                                            alt={'life'}
                                            src={lifeImg}
                                            className={'life-logo'}
                                        />
                                    </a>
                                </div>

                                <div className={'hcr-logo-div'}>
                                    <a href={"https://www.hcrimaging.com"}>
                                        <img
                                            alt={'hcr'}
                                            src={hcrImg}
                                            className={'hcr-logo'}
                                        />
                                    </a>
                                </div>

                                <div className={'overflow-nav'}>
                                    {this.state.uiConfig.authenticated
                                        && <NavLink
                                            title={'Profile'}
                                            to={AppPaths.PROFILE}>
                                            <Icon name={'user'}/>
                                        </NavLink>}

                                    {this.state.uiConfig.authenticated
                                        && <NavLink
                                            title={'Log out'}
                                            to={AppPaths.LOG_OUT}>
                                            <Icon name={'sign out'}/>
                                        </NavLink>}
                                </div>
                            </div>

                            {admin &&
                                <Menu
                                    className={'admin-menu'}
                                    floated={'right'}
                                >
                                    <Dropdown
                                        item={true}
                                        text={'Admin'}
                                        labeled={true}
                                        simple={true}
                                    >
                                        <Dropdown.Menu
                                            direction={'left'}
                                        >
                                            <Dropdown.Item as={this.renderAllOrdersLink}/>
                                            <Dropdown.Item as={this.renderAllUsersLink}/>
                                            <Dropdown.Item as={this.renderTrackingLink}/>
                                            <Dropdown.Item as={this.renderRnaCatalogLink}/>
                                            <Dropdown.Item as={this.renderProbeLotTableLink}/>
                                            <Dropdown.Item as={this.renderInventoryLink}/>
                                            <Dropdown.Item as={this.renderPresetScalesLink}/>
                                            <Dropdown.Item as={this.renderStarterKitsLink}/>
                                            <Dropdown.Item as={this.renderReferralsLink}/>
                                            {reports &&
                                                <Dropdown.Item as={this.renderReportsLink}/>}
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </Menu>
                            }

                            <nav>
                                <div className={'left'}>
                                    <a style={{marginRight: '22px'}} href={'https://www.molecularinstruments.com/products'}>Products</a>
                                    <a style={{marginRight: '22px'}} href={'https://www.molecularinstruments.com/technology'}>Technology</a>
                                    <a href={'https://www.molecularinstruments.com/about'}>About</a>
                                </div>

                                <div className={'right'}>
                                    <ShopLink to={AppPaths.LOCAL_NEW_KIT} navLink={true} marginRight={17}>
                                        <Icon name={'dna'}/>Shop
                                    </ShopLink>

                                    <NavLink to={AppPaths.CART}><Icon name={'cart'}/>Cart</NavLink>

                                    {this.state.uiConfig.authenticated
                                        && <NavLink style={{marginRight: '0px'}} to={AppPaths.ORDERS}><Icon
                                            name={'boxes'}/>My Orders</NavLink>}

                                    {!this.state.uiConfig.authenticated
                                        && <NavLink style={{marginRight: '0px'}}
                                                    to={AppPaths.LOG_IN}>
                                            <Icon name={'sign in'}/>Log In
                                        </NavLink>}
                                </div>
                            </nav>
                        </header>

                        <div id="main">
                            <AppNav
                                uiConfig={this.state.uiConfig}
                                authnObserver={this.authnObserver}
                                changeAppState={this.changeAppState}
                            />
                        </div>

                        <footer>
                            <nav>
                                <a href={"https://www.molecularinstruments.com/patents"}>Patents</a>
                                <a href={"https://www.molecularinstruments.com/terms"}>Terms</a>
                                <a href={"https://www.molecularinstruments.com/return-policy"}>Return Policy</a>
                                <a href={"https://www.molecularinstruments.com/privacy-policy"}>Privacy Policy</a>
                                <a href={"https://files.molecularinstruments.com/FCOIPolicy.pdf"}>FCOI</a>
                                <a href={"https://www.molecularinstruments.com/safety"}>Safety</a>
                                <a href={"https://www.molecularinstruments.com/references"}>References</a>
                                <a href={"https://www.molecularinstruments.com/gallery"}>Gallery</a>
                                <a href={"https://www.molecularinstruments.com/jobs"}>Jobs</a>
                                <a href={"https://www.molecularinstruments.com/contact"}>Contact</a>
                                <a href={"https://www.molecularinstruments.com/faq"}>FAQ</a>
                            </nav>
                            <div style={{textAlign: 'center', marginTop: '1em'}}>
                                <i>
                                    <p style={{marginBottom: 0}}>
                                        We recently updated our Terms.
                                    </p>
                                    <p>
                                        Please visit our <a
                                        href={"https://www.molecularinstruments.com/terms"}>Terms</a> to see the full
                                        details.
                                    </p>
                                </i>
                            </div>
                            <div className="copyright">
                                Copyright © {new Date().getFullYear()} Molecular Instruments, Inc. All rights reserved.
                            </div>
                        </footer>
                    </div>
                </Router>
            </UiConfigContext.Provider>
        </React.StrictMode>;
    }

    private readonly changeAppState = () => {
        this.setState({
            pathname: window.location.pathname
        }, this.forceUpdate)
    }

    private readonly renderAllOrdersLink = () => {
        return <Link to={AppPaths.ADMIN_ORDERS}><Icon name={'boxes'}/>Orders</Link>
    };
    private readonly renderAllUsersLink = () => {
        return <Link to={AppPaths.ADMIN_USERS}><Icon name={'address book'}/>Users</Link>
    };
    private readonly renderTrackingLink = () => {
        return <Link to={AppPaths.ADMIN_TRACKING}><Icon name={'clipboard'}/>Tracking</Link>
    };
    private readonly renderReportsLink = () => {
        return <Link to={AppPaths.ADMIN_REPORTS}><Icon name={'chart bar'}/>Reports</Link>
    };
    private readonly renderRnaCatalogLink = () => {
        return <Link to={AppPaths.ADMIN_RNA_CATALOG}><Icon name={'book'}/>RNA Catalog</Link>
    };
    private readonly renderProbeLotTableLink = () => {
        return <Link to={AppPaths.ADMIN_PROBE_LOT_TABLE}><Icon name={'table'}/>Probe Lot Table</Link>
    };
    private readonly renderInventoryLink = () => {
        return <Link to={AppPaths.ADMIN_INVENTORY}><Icon name={'table'}/>Inventory</Link>
    }

    private readonly renderPresetScalesLink = () => {
        return <Link to={AppPaths.ADMIN_PRESET_SCALES}><Icon name={'table'}/>Preset Scales</Link>
    }

    private readonly renderStarterKitsLink = () => {
        return <Link to={AppPaths.ADMIN_STARTER_KITS}><Icon name={'cart'}/>Starter Kits</Link>
    }

    private readonly renderReferralsLink = () => {
        return <Link to={AppPaths.MARKETING_REFERRALS}><Icon name={'ticket'}/>Marketing Referrals</Link>
    }

    private readonly loadUiConfig = () => {
        getWithAuthn('/user/ui-config')
            .then((resp) => {
                return resp.json()
            })
            .then((r: UiConfigResponse) => {
                this.setState({
                    uiConfig: {
                        authenticated: r.userId !== undefined && r.userId !== null,
                        uiFeatures: new Set<string>(r.uiFeatures),
                        isDefault: false,
                        userStatus: r.legacy === "LEGACY" ? "LEGACY" : "NON_LEGACY",
                        academic: r.academic
                    }
                });

                // if we're unauthenticated, need to make sure this isn't falsely attributed to the wrong user,
                // and if we are authenticated, want to attribute. Not sure what unsetting user id does to the session,
                // but it seems like the only reasonable thing to do.
                const gaUserId = r.userId === null ? undefined : r.userId;
                gtag('config', GOOGLE_ANALYTICS_ID, {user_id: gaUserId});
                gtag('config', GOOGLE_ANALYTICS4_ID, {user_id: gaUserId});
            })
            .catch((rej) => {
                console.error(`Couldn't check authn state: ${rej}`)
            })
    }
}

interface AppNavProps {
    readonly uiConfig: UiConfig;
    readonly authnObserver: AuthnObserver
    readonly changeAppState: () => void
}

// functional component so we can use useEffect to do our gtag
const AppNav = (navProps: AppNavProps) => {
    const admin = navProps.uiConfig.uiFeatures.has(FEATURE_SHOW_ADMIN_MENU);
    const reports = navProps.uiConfig.uiFeatures.has(FEATURE_REPORTS);
    const legacyUser = navProps.uiConfig.userStatus === "LEGACY"

    const v3PageErrorMessage = navProps.uiConfig.authenticated ?
        <React.Fragment>You do not have access to this page. Please contact <a
            href={"mailto:support@molecularinstruments.com"}>support@molecularinstruments.com</a> to be granted access
            or for more information.</React.Fragment> :
        <React.Fragment>
            You must be logged in to access this page. Please <Link to={AppPaths.LOG_IN}>log in</Link> and try again.
        </React.Fragment>

    const redirectShop = () => <ShopRedirect/>;

    const renderLogIn = (props: RouteComponentProps<any>) => {
        return <LogInPage
            authnObserver={navProps.authnObserver}
            routerProps={props}
            authenticated={navProps.uiConfig.authenticated}
        />;
    };
    const renderLogOut = () => {
        return <LogOutPage authnObserver={navProps.authnObserver}/>;
    };

    // Helper to be able to pass router props through
    const renderVerifyEmail = (props: RouterProps) => {
        return <VerifyEmailPage {...props}/>
    };
    const renderCart = (props: RouterProps) => {
        // we need to wait until the user config is done loading before we render the cart page.
        // Otherwise, we run into a problem where the wrong type of catalog is returned for cish.
        if (navProps.uiConfig.isDefault) {
            return <></>;
        }
        return <CartPage
            {...props}
            authenticated={navProps.uiConfig.authenticated}
            legacyUser={legacyUser}
        />
    };
    const renderResetPassword = (props: RouterProps) => {
        return <ResetPasswordPage {...props}/>
    };
    const renderOrderUploadPo = (props: RouterProps) => {
        return <OrderUploadPoPage {...props}/>
    };
    const renderAllOrders = (props: RouterProps) => {
        return <AllOrdersPage {...props}/>
    };
    const renderAllUsers = (props: RouterProps) => {
        return <AllUsersPage {...props}/>
    };
    const renderCishStarterKitPage = (props: RouterProps) => {
        return <ProStarterKitForm {...props}/>
    };
    const renderManualStarterKitPage = (props: RouterProps) => {
        return <ManualStarterKitForm {...props}/>
    };
    const renderReports = () => {
        return <ReportsPage/>
    };

    const renderConsumerCishPage = (props: RouterProps) => {
        return <NewMultiPlexProKitPage {...props} admin={admin}/>
    };

    const renderConsumerCishChromogenPage = () => {
        return <NewChromogenKitPage/>
    };

    const renderNewRnaFishKitPage = (ampOnly: boolean) => {
        return (_: RouteComponentProps<any>) => {
            return (
                <NewRnaFishKitPage
                    legacy={false}
                    adminUser={admin}
                    legacyUser={legacyUser}
                />
            );
        };
    }

    const renderManualProPage = (props: RouterProps) => {
        return <NewManualProConsumerKitPage {...props} adminUser={admin}/>
    };

    // wire GA to nav changes
    const location = useLocation();

    // as per https://developers.google.com/analytics/devguides/collection/gtagjs/single-page-applications
    React.useEffect(() => {
        gtag('config', GOOGLE_ANALYTICS_ID, {'page_path': location.pathname});
        gtag('config', GOOGLE_ANALYTICS4_ID, {'page_path': location.pathname});
        navProps.changeAppState();
    }, [location]);

    return <Switch>
        <Route exact={true} path='/' render={redirectShop}/>

        <Route exact={true} path={AppPaths.LOCAL_NEW_KIT}><NewKitPage/></Route>
        <Route path={AppPaths.LOCAL_NEW_KIT_RNA_FISH} render={renderNewRnaFishKitPage(false)}/>
        <Route path={AppPaths.LOCAL_NEW_GOLD_AMPLIFIER} render={renderNewRnaFishKitPage(true)}/>
        <Route path={AppPaths.LOCAL_NEW_KIT_ENCODER}><NewManualGoldIfKitPage adminUser={admin}/></Route>
        <Route path={AppPaths.LOCAL_NEW_KIT_IHC2}><NewSecondaryIfKitPage legacy={false} adminUser={admin}
                                                                  legacyUser={legacyUser}/></Route>
        <Route path={AppPaths.LOCAL_NEW_KIT_MANUAL_PRO} render={renderManualProPage}/>
        <Route path={AppPaths.CART} render={renderCart}/>
        <Route exact={true} path={AppPaths.REGISTER}><NewRegistrationPage/></Route>
        <Route path={AppPaths.LOG_IN} render={renderLogIn}/>
        <Route path={AppPaths.ORDERS} component={UserOrderListPage}/>
        <Route path={AppPaths.ORDER_PATTERN} component={UserOrderPage}/>
        <Route path={AppPaths.PROFILE}><ProfilePage/></Route>
        <Route path={AppPaths.LOG_OUT} render={renderLogOut}/>
        <Route path={'/user/verify-email'} render={renderVerifyEmail}/>
        <Route path={'/user/reset-password'} render={renderResetPassword}/>
        <Route path={AppPaths.ORDER_UPLOAD_PO} render={renderOrderUploadPo}/>

        <Route path={AppPaths.LOCAL_NEW_LEGACY_KIT_RNA_FISH}>
            {(legacyUser || admin) ?
                <NewRnaFishKitPage legacy={true} adminUser={admin} legacyUser={legacyUser}/> :
                <Message
                    error={true}
                    content={v3PageErrorMessage}/>}
        </Route>
        <Route path={AppPaths.LOCAL_NEW_LEGACY_KIT_IHC2}>
            {(legacyUser || admin) ?
                <NewSecondaryIfKitPage legacy={true} adminUser={admin} legacyUser={legacyUser}/> :
                <Message
                    error={true}
                    content={v3PageErrorMessage}/>}
        </Route>
        {admin && <Route path={AppPaths.LOCAL_NEW_KIT_RNA_CISH} render={renderConsumerCishPage}/>}
        {admin && <Route path={AppPaths.LOCAL_NEW_KIT_RNA_CISH_CHROMOGEN} render={renderConsumerCishChromogenPage}/>}
        {admin && <Route path={AppPaths.ADMIN_ORDERS} render={renderAllOrders}/>}
        {admin && <Route path={AppPaths.ADMIN_ORDER_PATTERN} component={SingleOrderPage}/>}
        {admin && <Route path={AppPaths.ADMIN_USERS} render={renderAllUsers}/>}
        {admin && <Route path={AppPaths.ADMIN_USER_PATTERN} component={SingleUserPage}/>}
        {admin && <Route path={AppPaths.ADMIN_TRACKING}><TrackingPage/></Route>}
        {admin && <Route path={AppPaths.ADMIN_RNA_CATALOG}><RnaCatalogPage/></Route>}
        {admin && <Route path={AppPaths.ADMIN_PROBE_LOT_TABLE}><ProbeLotTablePage/></Route>}
        {admin && <Route path={AppPaths.ADMIN_INVENTORY}><InventoryPage/></Route>}
        {admin && <Route path={AppPaths.ADMIN_FLUORESCENT_HAIRPIN_TRACKING}><FluorescentHairpinTrackingPage/></Route>}
        {admin && <Route path={AppPaths.ADMIN_MANUAL_BUFFER_TRACKING}><ManualBufferTrackingPage/></Route>}
        {admin && <Route path={AppPaths.ADMIN_ENCODER_TRACKING}><EncoderTrackingPage/></Route>}
        {admin && <Route path={AppPaths.ADMIN_SECONDARY_IF_PROBE_TRACKING}><SecondaryIfProbeTrackingPage/></Route>}
        {admin && <Route path={AppPaths.ADMIN_PRESET_SCALES}><PresetScalesPage/></Route>}
        {admin && <Route path={AppPaths.ADMIN_AUTOMATED_IF_PRESET_SCALES}><AutomatedIfPresetScalesPage/></Route>}
        {admin && <Route path={AppPaths.ADMIN_PRO_PROBE_PRESET_SCALES}><ProProbePresetScalesPage/></Route>}
        {admin && <Route path={AppPaths.ADMIN_PRO_DETECT_PRESET_SCALES}><ProDetectPresetScalesPage/></Route>}
        {admin && <Route path={AppPaths.ADMIN_CHROMOGEN_PRESET_SCALES}><ChromogenPresetScalesPage/></Route>}
        {admin && <Route path={AppPaths.ADMIN_STARTER_KITS}><StarterKitsPage/></Route>}
        {admin && <Route path={AppPaths.ADMIN_RNA_CISH_STARTER_KIT} render={renderCishStarterKitPage}/>}
        {admin && <Route path={AppPaths.ADMIN_MANUAL_STARTER_KIT} render={renderManualStarterKitPage}/>}
        {admin && reports && <Route path={AppPaths.ADMIN_REPORTS} render={renderReports}/>}
        {admin && <Route path={AppPaths.MARKETING_REFERRALS}><MarketingReferralsPage/></Route>}
    </Switch>
};

export default App;

interface AppState {
    readonly uiConfig: UiConfig,
    pathname: string
}

interface UiConfigResponse {
    readonly userId?: string,
    readonly uiFeatures: string[],
    readonly legacy: string,
    readonly academic: boolean
}

const FEATURE_SHOW_ADMIN_MENU = 'showAdminMenu';
const FEATURE_REPORTS = 'adminReports';



// WEBPACK FOOTER //
// ./src/App.tsx